
export const BaseHosts = {
  Int: 'https://stage.searchads.payments.yahoo.com',
  Prod: 'https://searchads.payments.yahoo.com',
};

export const Path = 'api/v1/auth';

export const Actions = {
  SpendAccount: 'spend-account',
  PaymentMethods: 'payment-instruments',
  CompanyInformation: 'company-information',
  BillingReports: 'billing',
};

export const YahooDataDisplayHints = {
  // Yahoo! data is not available and should not be attempted to be rendered.
  NotAvailable: 0,
  // Yahoo! data is displayed (instead of Bing Ads data).
  Visible: 1,
  // Yahoo! data is available, but it's not displayed.
  // The user should be allowed to choose between Yahoo! and Bing Ads data.
  Optional: 2,
};
